// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

// GET /ip-whitelist/check - public, no auth
export async function checkIp() {
  return request<{ allowed: boolean; ip: string }>('/ip-whitelist/check', {
    method: 'GET',
    skipErrorHandler: true,
  });
}

// GET /ip-whitelist - list with pagination
export async function listIpWhitelist(params: { page?: number; limit?: number; ip?: string }) {
  return request<{ data: API.IpWhitelistItem[]; total: number }>('/ip-whitelist', {
    method: 'GET',
    params,
  });
}

// POST /ip-whitelist
export async function createIpWhitelist(body: { ip: string; note?: string; isActive?: boolean }) {
  return request<API.IpWhitelistItem>('/ip-whitelist', { method: 'POST', data: body });
}

// PUT /ip-whitelist/:id
export async function updateIpWhitelist(
  id: number,
  body: { ip?: string; note?: string; isActive?: boolean },
) {
  return request<API.IpWhitelistItem>(`/ip-whitelist/${id}`, { method: 'PUT', data: body });
}

// DELETE /ip-whitelist/:id
export async function deleteIpWhitelist(id: number) {
  return request(`/ip-whitelist/${id}`, { method: 'DELETE' });
}
